import { GetPersonListItemType as ApiPersonListItemType } from 'src/api/generated/touring/types';
import { mapContact } from '../common';
import { mapPersonListItemCompanyType } from './helpers';
import { PersonListItemType } from './types';

export const mapPersonListItemType = (
  apiPerson: ApiPersonListItemType
): PersonListItemType => {
  return {
    id: apiPerson.id,
    firstname: apiPerson.firstname,
    lastname: apiPerson.lastname,
    nickname: apiPerson.nickname || null,
    contact: mapContact(apiPerson.contact),
    companyName: apiPerson.companyName || null,
    companies: apiPerson.companies.map(mapPersonListItemCompanyType),
  };
};
